import API from '@/api';

async function getWallet(data) {
  const response = await API.get(`/wallet`, data);

  return response.data;
}

async function updateWalletSettings(data) {
  const response = await API.post(`/wallet/settings`, data);

  return response.data;
}

async function createWallet() {
  const response = await API.post(`/wallet`);

  return response.data;
}

export default {
  getWallet,
  updateWalletSettings,
  createWallet,
};
